import './App.css';
// import Test from './components/Test';
import TopBar from './components/TopBar';
function App() {
  return (
    <div className="App">
      <TopBar />
      {/* <Test /> */}
    </div>
  );
}

export default App;
